import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Sparkle } from "lucide-react";
import { API, axios } from "@/lib/api";

const SocialProofTicker = () => {
  const [items, setItems] = useState([]);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    axios.get(`${API}/social-proof`).then(({ data }) => setItems(data)).catch(() => {});
  }, []);

  useEffect(() => {
    if (items.length < 2) return;
    const t = setInterval(() => setIndex((i) => (i + 1) % items.length), 4000);
    return () => clearInterval(t);
  }, [items.length]);

  if (items.length === 0) return null;
  const current = items[index];

  return (
    <div className="flex items-center justify-center py-4 border-b border-white/5" data-testid="social-proof-ticker">
      <AnimatePresence mode="wait">
        <motion.p
          key={`${current.business}-${index}`}
          initial={{ opacity: 0, y: 6 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -6 }}
          transition={{ duration: 0.4 }}
          className="flex items-center gap-2 text-xs md:text-sm text-zinc-500"
        >
          <Sparkle size={13} className="text-[#ccff00]" />
          {current.first_name ? `${current.first_name} just launched ` : "Just launched: "}
          <span className="text-zinc-300 font-medium">{current.business}</span>
        </motion.p>
      </AnimatePresence>
    </div>
  );
};

export default SocialProofTicker;
